// Online/offline state of a rating kiosk from its last heartbeat
// (facility.device_last_seen, stamped by GET /v1/device/config every
// ~5 min - backend/routes/DeviceConfig.ts). Three missed calls = offline.
export const KIOSK_OFFLINE_AFTER_MINUTES = 15;

export function kioskStatus(lastSeen, now = Date.now()) {
  if (!lastSeen) return { state: 'never', minutes: null };
  const minutes = Math.max(0, Math.round((now - new Date(lastSeen).getTime()) / 60000));
  return { state: minutes <= KIOSK_OFFLINE_AFTER_MINUTES ? 'online' : 'offline', minutes };
}

// "3 min", "2 h", "5 j" - compact, for chips.
export function shortDuration(minutes) {
  if (minutes < 60) return `${minutes} min`;
  if (minutes < 48 * 60) return `${Math.round(minutes / 60)} h`;
  return `${Math.round(minutes / 1440)} j`;
}
